module.exports = __webpack_public_path__ + "media/bootstrap-icons/bullseye-2449d144.svg";